/*
 * Copyright (c) 2022-present New Relic Corporation. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
export var NREnums;
(function (NREnums) {
    let LogLevel;
    (function (LogLevel) {
        LogLevel["ERROR"] = "ERROR";
        LogLevel["WARNING"] = "WARNING";
        LogLevel["INFO"] = "INFO";
        LogLevel["VERBOSE"] = "VERBOSE";
        LogLevel["AUDIT"] = "AUDIT";
    })(LogLevel = NREnums.LogLevel || (NREnums.LogLevel = {}));
    let NetworkFailure;
    (function (NetworkFailure) {
        NetworkFailure["Unknown"] = "Unknown";
        NetworkFailure["BadURL"] = "BadURL";
        NetworkFailure["TimedOut"] = "TimedOut";
        NetworkFailure["CannotConnectToHost"] = "CannotConnectToHost";
        NetworkFailure["DNSLookupFailed"] = "DNSLookupFailed";
        NetworkFailure["BadServerResponse"] = "BadServerResponse";
        NetworkFailure["SecureConnectionFailed"] = "SecureConnectionFailed";
    })(NetworkFailure = NREnums.NetworkFailure || (NREnums.NetworkFailure = {}));
    let MetricUnit;
    (function (MetricUnit) {
        MetricUnit["PERCENT"] = "PERCENT";
        MetricUnit["BYTES"] = "BYTES";
        MetricUnit["SECONDS"] = "SECONDS";
        MetricUnit["BYTES_PER_SECOND"] = "BYTES_PER_SECOND";
        MetricUnit["OPERATIONS"] = "OPERATIONS";
    })(MetricUnit = NREnums.MetricUnit || (NREnums.MetricUnit = {}));
})(NREnums || (NREnums = {}));
//# sourceMappingURL=definitions.js.map